import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairTransferGuideContent } from "../../PairTransferGuideContent";

export default function TransferYoutubeToAppleMusic() {
    return (
        <GuidesPage
            seoData={seoContent.transferYoutubeToAppleMusic}
            sections={<PairTransferGuideContent sourceKey="youtube" destKey="appleMusic" />}
        />
    );
}
